import {
  hexToRGB,
  MOON_200,
  MOON_600,
  MOON_700,
  MOON_800,
  TEAL_300,
  TEAL_700,
} from '@wandb/weave/common/css/globals.styles';
// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Icon} from '@wandb/weave/components/Icon';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const FlashIcon = styled(Icon)`
  color: sienna;
  width: 24px;
  height: 24px;
`;

export const JobContent = styled.div`
  flex: 1;
  min-width: 0;
`;

export const JobName = styled.div`
  font-weight: 400;
  font-size: 20px;
  color: ${MOON_800};
  margin-bottom: 4px;
`;

export const JobDescription = styled.div`
  font-size: 14px;
  color: ${MOON_600};
  line-height: 21px;
`;

export const LaunchButton = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  width: 40px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  background-color: transparent;
  color: ${MOON_700};

  &:hover {
    background-color: ${MOON_200};
    color: ${MOON_800};
  }

  &:focus {
    background-color: ${MOON_200};
    color: ${MOON_800};
    outline: 2px solid ${MOON_700};
    outline-offset: 2px;
  }

  &:active {
    background-color: ${hexToRGB(TEAL_300, 0.48)};
    color: ${TEAL_700};
  }
`;

export const LaunchIcon = styled(Icon)`
  color: inherit;
  width: 20px;
  height: 20px;
`;

export const JobCard = styled.div`
  display: flex;
  align-items: center;
  padding: 16px;
  border: 1px solid ${MOON_200};
  border-radius: 8px;
  background-color: white;
  transition: all 0.2s ease;
  cursor: pointer;
`;

export const FlashIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  margin-right: 16px;
  flex-shrink: 0;
  background-color: #ffe0cc;
`;
